import { TableQuery } from '../../../interfaces/table-query';
import { TableColumn } from '../../../models/table-column';
import { switchMap, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import * as XLSX from 'xlsx/xlsx.mjs';

export abstract class TableExportService<E, Q> {

    protected render(c: TableColumn, e: E): any {
        if (c.export) {
            return c.export(e);
        }
        if (c.render) {
            return c.render(e);
        }
        return '';
    }

    protected compile(columns: TableColumn[], source: TableQuery<E, Q>, query: Q, progress: (percent: number) => void): Observable<any[][]> {
        progress(0);
        const header = columns.map(c => c.caption);
        const rows = [ header ];
        const fetch = (p) => source.query({ ...query, pageNumber: p, itemsPerPage: 500 }).pipe(
            tap(page => page.page.forEach(r => rows.push(columns.map(c => this.render(c, r))))),
            tap(page => page.totalCount ? progress(Math.round(rows.length * 100 / page.totalCount)) : progress(0)),
            switchMap(page => page.totalCount > rows.length ? fetch(p + 1) : of(rows))
        );
        return fetch(1);
    }

    protected produce(dataset: any[][], filename: string): void {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(dataset);
        XLSX.utils.book_append_sheet(workbook, worksheet);
        XLSX.writeFile(workbook, filename);
    }

}
